import * as React from "react";
import { SFT_Targets } from "../models/SFT_Targets";
import { countrydetails } from "../models/countrydetails";
import { Chart } from "react-google-charts";
import { TargetSpecModal } from "./TargetSpecModal";
import { ProtectiveFunction } from "../models/ProtectiveFunction";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { HFTResults } from "../models/HFTResults";
import { pfdToSil, formatPieChartLabels } from "../helpers";
import { CalculationResultsView } from "../models/CalculationResultsView";
import { HftBreakdownResults } from "../models/HftBreakdownResults";
import { CalculationResults } from "../models/CalculationResults";


interface Props {
    sftTargets?: SFT_Targets,
    calculations?: CalculationResults,
    pfdPieChartData: countrydetails[],
    strPieChartData: countrydetails[],
    calculationResults?: PT_ProtectiveFunction,
    hftResults?: HFTResults
    protectiveFunction: ProtectiveFunction,
    handleTargetSpecUpdate: (target_pfd: number, target_mttf: number) => void,
};

interface State {
  shownModal: null | "targetSpecModal";
}

export class FunctionStatsHeader extends React.Component<Props, State> {
    constructor(props: Props) {
      super(props);
      this.state = {
        shownModal: null,
      }
      this.closeModal = this.closeModal.bind(this);
    }

    private displayNumber(number: number) {
        return number != null ? number.toFixed(2) : "";
    }

    private handleClick = (e) => {
      this.setState({
        shownModal: "targetSpecModal"
      })
    }

    closeModal() {
      this.setState({
        shownModal: null,
      });
    }

    render() {
        const targetStyle: React.CSSProperties = {
            color: "blue"
        };
        const resultStyle: React.CSSProperties = {
            color: "red"
        };

        const defaultStyle: React.CSSProperties = {
            backgroundColor: "#EEEEEE"
        };

        const passStyle: React.CSSProperties = {
            backgroundColor: "#00FF00"
        };

        const failStyle: React.CSSProperties = {
            backgroundColor: "#FF0000"
        };

        // Set targets
        let targetPfdAvg = "", targetSil = "", targetStr = "", targetMttf = "", targetHft = "";
        if (this.props.sftTargets != null) {
            targetPfdAvg = this.props.sftTargets.xpfDavg;
            targetSil = this.displayNumber(this.props.sftTargets.sil);
            targetStr = this.props.sftTargets.xstR1Year;
            targetMttf = this.displayNumber(this.props.sftTargets.mttf);
            targetHft = this.props.sftTargets.hftTarget && this.props.sftTargets.hftTarget.toString();
        }

        // Set results
      const resultsView = new CalculationResultsView(this.props.calculationResults, this.props.hftResults);
        let pfdMetStyle = defaultStyle, silMetStyle = defaultStyle, strMetStyle = defaultStyle, mttfMetStyle = defaultStyle, hftMetStyle = defaultStyle;
        if (this.props.calculationResults != null) {

            if (this.props.sftTargets != null) {
                pfdMetStyle = this.props.calculationResults.pfdAverage <= this.props.sftTargets.pfDavg ? passStyle : failStyle;
                silMetStyle = pfdToSil(this.props.calculationResults.pfdAverage) >= pfdToSil(this.props.sftTargets.pfDavg) ? passStyle : failStyle;
                strMetStyle = this.props.calculationResults.stR1Year < this.props.sftTargets.stR1Year ? passStyle : failStyle;
                mttfMetStyle = (1 / this.props.calculationResults.stR1Year) >= this.props.sftTargets.mttf ? passStyle : failStyle;
                hftMetStyle = this.props.hftResults.system >= this.props.sftTargets.hftTarget ? passStyle : failStyle;
            }
        }

      const hftBreakdown = new HftBreakdownResults(this.props.hftResults, this.props.sftTargets && this.props.sftTargets.hftTarget);

        return (
            <div style={{ "borderTop": "1px solid black", "borderLeft": "1px solid black", "borderRight": "1px solid black", "padding": "3px 0px", "width": "100%"}}>
                <table className="header_bottom" style={{"width": "100%"}}>
                    <tbody>
                        <tr style={{ "width": "100%" }}>
                            <td className="head_left_part" style={{ "width": "40%", "display": "table-cell" }}>
                                <table className="summary_tab_container" style={{ "padding": "1px" }}>
                                    <tbody>
                                        <tr>
                                            <th className="wid_20"></th>
                                            <th className="wid_20" style={{"width": "6em"}}>PFDavg</th>
                                            <th className="wid_20">IL</th>
                                            <th className="wid_20" style={{"width": "6em"}}>STR (1/Yr)</th>
                                            <th className="wid_20">MTTFs<br />(Yr)</th>
                                            <th className="wid_20">HFT</th>
                                        </tr>
                                        <tr onClick={(e: React.MouseEvent) => this.handleClick(e)} >
                                            <td>
                                                  <label id="label_target">Targets</label>
                                            </td>
                                            <td>
                                                <input type="text" readOnly id="txtpfdavg" style={targetStyle} value={targetPfdAvg} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly id="txtsil" style={targetStyle} value={targetSil} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly id="txtstr" style={targetStyle} value={targetStr} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly id="txtmttf" style={targetStyle} value={targetMttf} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly id="txthft" style={targetStyle} value={targetHft} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Results</label>
                                            </td>
                                            <td>
                                                <input type="text" readOnly className="readonlyCell" id="result_pfd" style={resultStyle} value={resultsView.pfdAvg} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly className="readonlyCell" id="result_sil" style={resultStyle} value={resultsView.sil} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly className="readonlyCell" id="result_str" style={resultStyle} value={resultsView.str} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly className="readonlyCell" id="result_mttf" style={resultStyle} value={resultsView.mttf} />
                                            </td>
                                            <td>
                                                <input type="text" readOnly className="readonlyCell" id="result_hft" style={resultStyle} value={resultsView.hft} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Targets Met?</label>
                                            </td>
                                            <td>
                                                <input id="meetpfd" readOnly className="readonlyCell" type="text" style={pfdMetStyle} value={""} />
                                            </td>
                                            <td>
                                                <input id="meetsil" readOnly className="readonlyCell" type="text" style={silMetStyle} value={""}/>
                                            </td>
                                            <td>
                                                <input id="meetstr" readOnly className="readonlyCell" type="text" style={strMetStyle} value={""} />
                                            </td>
                                            <td>
                                                <input id="meetmttf" readOnly className="readonlyCell" type="text" style={mttfMetStyle} value={""} />
                                            </td>
                                            <td>
                                                <input id="meethft" readOnly className="readonlyCell" type="text" style={hftMetStyle} value={""} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td className="head_meddile_part" style={{ "width": "40%", "display": "table-cell" }}>
                                <div style={{ "height": "125px", "textAlign": "center", "width": "100%" }}>
                                    <div style={{ "height": "20px", "width": "100%" }}>
                                        <label id="Label17" style={{"color": "black", "fontWeight": "bold", "fontSize": "larger"}}>PFD/STR Breakdown</label>
                                    </div>
                                    <div id="piecharts" style={{height: "104px", padding: "0px 10px; width: 100%"}}>
                                        <div id="PFD" style={{ border: "2px solid", float: "left", width: "49%", height: "100%" }}>
                                            <Chart
                                                chartType="PieChart"
                                                options={{ title: "PFDavg", pieSliceText: "none" }}
                                                data={[["Section", "Contribution"], ...formatPieChartLabels(this.props.pfdPieChartData).map(row => [row.countryname, row.total])]}
                                                width={"100%"}
                                                height={"100%"}
                                            />
                                        </div>
                                        <div id="STR" style={{ border: "2px solid", float: "right", width: "49%", height: "100%" }}>
                                            <Chart
                                                chartType="PieChart"
                                                options={{ title: "STR", pieSliceText: "none" }}
                                                data={[["Section", "Contribution"], ...formatPieChartLabels(this.props.strPieChartData).map(row => [row.countryname, row.total])]}
                                                width={"100%"}
                                                height={"100%"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td className="hft-breakdown-chart" id="hft-breakdown-chart" style={{ paddingRight: "10px" }}>
                                <div>
                                    <table className="summary_tab_container">
                                        <tbody>
                                            <tr>
                                                <th>HFT<sub>IN</sub></th>
                                                <th>HFT<sub>LS</sub></th>
                                                <th>HFT<sub>ACT</sub></th>
                                            </tr>
                                            <tr>
                                                <td><input readOnly id="hft-in" className="readonlyCell" type="number" {...hftBreakdown.hftIn} /></td>
                                                <td><input readOnly id="hft-ls" className="readonlyCell" type="number" {...hftBreakdown.hftLs} /></td>
                                                <td><input readOnly id="hft-act" className="readonlyCell" type="number" {...hftBreakdown.hftAct} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <table className="summary_tab_container">
                                        <tbody>
                                            <tr>
                                                <th>HFT<sub>SPT1</sub></th>
                                                <th>HFT<sub>SPT2</sub></th>
                                                <th>HFT<sub>MIN</sub></th>
                                                <th>HFT<sub>MACT</sub></th>
                                            </tr>
                                            <tr>
                                                <td><input readOnly id="hft-spt1" className="readonlyCell" type="number" {...hftBreakdown.hftSpt1} /></td>
                                                <td><input readOnly id="hft-spt2" className="readonlyCell" type="number" {...hftBreakdown.hftSpt2} /></td>
                                                <td><input readOnly id="hft-min" className="readonlyCell" type="number" {...hftBreakdown.hftMin} /></td>
                                                <td><input readOnly id="hft-mact" className="readonlyCell" type="number" {...hftBreakdown.hftMact} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                            <td />
                        </tr>
                    </tbody>
            </table >
            {this.state.shownModal === "targetSpecModal" ?

              <TargetSpecModal
                closeModal={this.closeModal}
                sftTargets={this.props.sftTargets}
                protectiveFunction={this.props.protectiveFunction}
                handleTargetSpecUpdate={this.props.handleTargetSpecUpdate}
              />
              :
              null
            }
            </div >
        );
    }
}